import { Components, Theme } from '@mui/material/styles';

export const muiPaperOverride: Components<Omit<Theme, 'components'>>['MuiPaper'] = {
  styleOverrides: {
    root: {
      borderRadius: '8px'
    }
  }
};
